import { Mark } from '@tiptap/core'

const TiptapBackgroundColor = Mark.create({
  name: 'backgroundColor',

  addOptions () {
    return {
      backgroundColor: ['#dbc590']
    }
  },

  addAttributes () {
    return {
      backgroundColor: {
        default: '#dbc590',
        parseHTML: element => {
          return element.style.backgroundColor || element.getAttribute('data-background-color') || '#dbc590'
        },
        renderHTML: attrs => {
          return {
            style: `background-color:${attrs.backgroundColor}`
          }
        }
      }
    }
  },

  parseHTML () {
    return [
      {
        tag: 'mark'
      }
    ]
  },

  renderHTML ({ HTMLAttributes }) {
    return ['mark', HTMLAttributes, 0]
  },

  addCommands () {
    return {
      backgroundColor: attrs => ({ commands }) => {
        if (!attrs || !attrs.backgroundColor) {
          return commands.unsetMark(this.name)
        }

        return commands.setMark(this.name, attrs)
      }
    }
  }
})

export default TiptapBackgroundColor
